import PropTypes from "prop-types";

const LovdGeneType = {
  data: PropTypes.shape({
    lovd_link: PropTypes.string,
    number_of_individuals: PropTypes.number,
    number_of_variants: PropTypes.number,
    phenotypes: PropTypes.arrayOf(
      PropTypes.shape({
        term: PropTypes.string,
        source: PropTypes.string,
        accession: PropTypes.string,
        inheritance_pattern: PropTypes.shape({
          term: PropTypes.arrayOf(PropTypes.string),
          source: PropTypes.string,
          accession: PropTypes.string,
        }),
      })
    ),
    version: PropTypes.string,
  }),
};

export default LovdGeneType;
